// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_REVIEW = "Opravdu chce\u0161 vymazat hodnocen\u00ed?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_REVIEW_REPLY = "Opravdu chce\u0161 vymazat odpov\u011b\u010f na hodnocen\u00ed?";
